import { render, staticRenderFns } from "./CourseStatistics.vue?vue&type=template&id=3d922786&scoped=true"
import script from "./CourseStatistics.vue?vue&type=script&lang=js"
export * from "./CourseStatistics.vue?vue&type=script&lang=js"
import style0 from "./CourseStatistics.vue?vue&type=style&index=0&id=3d922786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d922786",
  null
  
)

export default component.exports